<template>

    <div class="row h-100">
        <div class="col-sm-10 col-md-11 col-lg-8 my-auto mx-auto">
            <div class="row">
                <div class="col-md-6 bg-white py-5 px-5">
                    <div class="row">
                        <div class="col-12 px-5 px-md-2">

                            <h1 class="text-center mb-3">
                                <span>Register</span>
                            </h1>

                            <!-- Success Message -->
                            <div v-if="submitted" class="alert alert-success text-center">
                                <h5>Registration Submitted!</h5>
                                <p class="mb-0">Thank you for registering. Our team will review your request and contact you shortly to complete the onboarding process.</p>
                                <router-link to="/login" class="btn btn-outline-primary mt-3">Back to Login</router-link>
                            </div>

                            <template v-else>
                                <kt-input
                                    class="my-2"
                                    v-model="name"
                                    label="Name"
                                    type="text"
                                    placeholder="Enter your full name"
                                    required
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-user"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>

                                <kt-input
                                    class="my-2"
                                    v-model="email"
                                    label="Email"
                                    type="email"
                                    placeholder="Enter your email"
                                    required
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-envelope"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>

                                <kt-input
                                    class="my-2"
                                    v-model="phone"
                                    label="Phone"
                                    type="tel"
                                    placeholder="Enter your phone number"
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-phone"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>

                                <kt-input
                                    class="my-2"
                                    v-model="domain"
                                    label="Preferred Domain"
                                    type="text"
                                    placeholder="yourcompany (for yourcompany.7thleveltech.com)"
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-globe"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>
                                <small class="text-muted d-block mb-2">This will be your subdomain for accessing the app</small>

                                <kt-input
                                    class="my-2"
                                    v-model="password"
                                    label="Password"
                                    type="password"
                                    placeholder="Enter your password"
                                    required
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                            <i class="fas fa-lock"></i>
                                        </div>
                                    </template>
                                </kt-input>

                                <div class="text-center">
                                    <button 
                                        class="btn btn-outline-primary mt-4 py-2 px-4 form-control" 
                                        @click="submit()"
                                        :disabled="isSubmitting"
                                    >
                                        <span v-if="isSubmitting">Submitting...</span>
                                        <span v-else>Register</span>
                                    </button>
                                </div>

                                <div class="text-center my-3">
                                    <span class="text-muted">Already have an account? 
                                        <router-link to="/login" class="text-muted">Log in</router-link>
                                    </span>
                                </div>
                            </template>
                        </div>
                    
                    </div>
                </div>
                <div class="col-md-6 bg-login p-0">
                    <div class="bg h-100 d-flex py-3">
                        <div class="text-center my-auto text-white w-50 mx-auto">
                            <h4>
                                <img src="/images/favicon.png" alt="7th Level Technologies" style="width: 25%; max-width: 100%; height: auto;" class="mb-3"><br />
                                Manage project time and resources with ease.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import { ref } from "vue";
import { useRouter } from "vue-router";
import Api from "@/services/ApiService";
import Alert from "@/services/Alert";
import KtInput from "@/components/UI/KtInput.vue"; 

const name = ref("");
const email = ref("");
const phone = ref("");
const domain = ref("");
const password = ref("");
const router = useRouter();
const isSubmitting = ref(false);
const submitted = ref(false);

const submit = async () =>
{
    // Validate required fields
    if (!name.value || !email.value || !password.value)
    {
        Alert.notify({
            text: "Please enter your name, email, and password"
        });
        return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.value))
    {
        Alert.notify({
            text: "Please enter a valid email address"
        });
        return;
    }

    // Validate domain format (alphanumeric and hyphens only, no spaces)
    if (domain.value && !/^[a-zA-Z0-9-]+$/.test(domain.value))
    {
        Alert.notify({
            text: "Domain can only contain letters, numbers, and hyphens"
        });
        return;
    }

    isSubmitting.value = true;

    try {
        const res = await Api.register({
            name: name.value,
            email: email.value,
            phone: phone.value,
            domain: domain.value.toLowerCase(),
            password: password.value
        });
        
        console.debug("register response", res);

        if (res && res.Status === 1)
        {
            submitted.value = true;
        }
        else
        {
            Alert.notify({
                text: res?.Message || "Registration failed. Please try again."
            });
        }
    }
    catch (error) {
        console.error("Registration error:", error);
        Alert.notify({
            text: "An error occurred during registration. Please try again."
        });
    }
    finally {
        isSubmitting.value = false;
    }
}

</script>

<style>
#app.register {
    background: #212121;
}

.bg-login {
    background-image: url("/images/login_bg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    
}

.bg-login > .bg {
    background: linear-gradient(180deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.74) 50%, rgba(0, 0, 0, 1) 100%);
}
</style>